import { sharedCoreEn } from "./shared-core";

export const platformSupport = {
  actions: {
    cancel: "Cancel",
    confirm: "Confirm",
  },
  common: {
    title: "AIRange",
    locale: "Language",
    phase: "Phase",
    languageChanged: "Language switched to {locale}",
  },
  shared: sharedCoreEn,
  shareMode: {
    private: "Private",
    shared_to_users: "Shared to Selected Users",
    public: "Public",
  },
} as const;
